import { render, staticRenderFns } from "./applicationEdit.vue?vue&type=template&id=63cf3cc2&scoped=true&"
import script from "./applicationEdit.vue?vue&type=script&lang=js&"
export * from "./applicationEdit.vue?vue&type=script&lang=js&"
import style0 from "./applicationEdit.vue?vue&type=style&index=0&id=63cf3cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf3cc2",
  null
  
)

export default component.exports